module.exports = __webpack_public_path__ + "static/media/ico-joined.a837df32.svg";